module.exports = __webpack_public_path__ + "media/MediumIllustrationHouse@2x.ae4f21ca.png";